<template>
  <div>
    <div class="my-5">
      <div class="text-gray-200 font-hairline text-base">SALDO</div>
      <span class="inline-block bg-gray-100 rounded-full px-3 py-1 text-xl font-bold text-teal-700 mb-2">
        {{ currency(saldo, { decimal: ",", separator: "." }).format() }}
      </span>
    </div>

    <div v-if="ultimaSolicitud">
      <div class="text-sm text-teal-200">Ultima solicitud</div>
      <div class="pb-5 text-white text-2xl font-bold">{{ ultimaSolicitud }}</div>
    </div>

    <div class="m-4">
      <div class="flex flex-row gap-2 items-center my-2">
        <button class="rounded-full bg-paleta-3" @click="volver">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" class="h-8 w-8 p-1" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
            <path
              fill="currentColor"
              d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
            ></path>
          </svg>
        </button>
        <div class="text-white text-base">Mi cuenta</div>
      </div>
    </div>
    <OpcionMenu titulo="Recarga" descripcion="Recarga de crédito por varios medios de pagos" v-on:clickeado="recarga" to="" :desactivado="recargaDesactivada" />
    <OpcionMenu titulo="Retiro" descripcion="Solicitud de retiro de fondos por ventanilla" to="/miCuenta/retiro" desactivado="false" />
    <OpcionMenu titulo="Datos personales" descripcion="Administración de datos personales" to="/miCuenta/datosPersonales" desactivado="false" />
    <OpcionMenu titulo="Cambiar contraseña" descripcion="Cambiar contraseña" to="/miCuenta/cambiarContrasena/cambiarContrasena" desactivado="false" />
    <OpcionMenu titulo="Salir" descripcion="Cerrar sesión" to="/" desactivado="false" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import OpcionMenu from "@/components/OpcionMenu";
import currency from "currency.js";

export default {
  components: {
    OpcionMenu
  },
  data() {
    return {
      currency: currency
    };
  },
  methods: {
    volver() {
      this.$router.go(-1);
    },
    click: function(numero) {
      this.$store.dispatch("agregarDigitoVales", { numero });
    },
    recarga() {
      this.$router.push("/miCuenta/recarga");
    },
    onNotify: function() {
      console.log("NOTIFY");
    }
  },
  computed: {
    ...mapState({
      saldo: state => state.sesion.usuario.saldo,
      ultimaSolicitud: state => state.recarga.codigoOperacion,
      mensaje: state => state.sesion.mensajeEstado,
      recargaDesactivada: state => state.sesion.usuario.geoControl.accion === "NO_HABILITADA" ||  state.sesion.usuario.datosPersonales.accion != "OK"
    })
  }
};
</script>
